import { render, staticRenderFns } from "./AcceleratorProfile.vue?vue&type=template&id=a8fc1d06&scoped=true&"
import script from "./AcceleratorProfile.vue?vue&type=script&lang=js&"
export * from "./AcceleratorProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8fc1d06",
  null
  
)

export default component.exports